// @flow
import { uniqBy } from 'lodash';

import type { ArticleType, CategoryArticleType } from 'types/Article';

export function getArticlesLabels(articles: Array<ArticleType>) {
  return articles
    .reduce(
      (accumulator, currentValue) =>
        accumulator.find(label => label.slug === currentValue.label.slug) ?
          accumulator :
          [...accumulator, currentValue.label],
      []
    );
}

export const getNews = (categoriesArticle: CategoryArticleType[]) => {
  const news = [];

  if (categoriesArticle && categoriesArticle.length > 0) {
    categoriesArticle.forEach(cat => {
      if (cat.items && cat.items.length > 0) {
        cat.items.forEach((actu, i) => {
          news.push(actu);
        });
      }
    });
  }

  const filteredNews = news.filter((item: ArticleType, index: number): boolean => news.indexOf(item.link) !== index)
    .sort((a,b) => {
      const x = a.date.toString();
      const y = b.date.toString();
      return y < x ? -1 : y > x ? 1 : 0;
    });

  const results = (): any[] => uniqBy(filteredNews, 'id').slice(0, 6);

  return results();
};
